(function (window) {
  function resetClusterSettings() {
    window.per.clustering_icon_mode_sel = "average";
    window.per.clustering_icon_col = -1;
    window.clustering_icon_cb_status = false;
  }

  function setClusterSettings(
    clustering_icon_mode_sel,
    clustering_icon_col,
    clustering_icon_cb_status,
  ) {
    window.per.clustering_icon_mode_sel = clustering_icon_mode_sel;
    window.per.clustering_icon_col = clustering_icon_col;
    window.per.clustering_icon_cb_status = clustering_icon_cb_status;
  }

  function createIframeCodeElement() {
    // get the current map url
    const src = window.location.href;

    // create link to map
    const link =
      "<p><small>View <a href='" + src + "'>full screen map</a></small></p>";

    const baseURL = window.location.origin;

    // create the iframe code to be displayed
    const iframeCode =
      '<p><iframe src="' +
      src +
      '" width="100%" height="550" sandbox="allow-top-navigation allow-scripts allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-modals allow-forms" allow="geolocation ' +
      baseURL +
      '" style="border:1px solid #aaa; position: relative;" scrolling="no" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe><p>' +
      link;

    // create the container div
    const container = document.createElement("div");
    container.classList.add("iframe-code-container");

    // create label/copy container
    const labelContainer = document.createElement("div");
    labelContainer.classList.add("label-container");

    // create the label
    const label = document.createElement("label");
    label.textContent = "Embed Code";
    label.classList.add("iframe-code-label");

    // create the textarea
    const textarea = document.createElement("textarea");
    textarea.id = "iframe-code-area";
    textarea.classList.add("iframe-code-textarea");
    textarea.readOnly = true; // make it readonly

    // if for some reason there is no src or iframeCode alert the user, otherwise pass iframeCode
    textarea.textContent =
      !src || !iframeCode ? "No iframe code generated" : iframeCode;

    // create the copy button
    const copyButton = document.createElement("button");
    copyButton.id = "copy-button";
    copyButton.innerHTML = "&#128203;"; // clipboard

    // create message location
    const message = document.createElement("p");
    message.classList.add("message");
    message.id = "message";
    message.textContent = " ";

    // add click event listener to the button
    copyButton.addEventListener("click", () => {
      const textToCopy = document.getElementById("iframe-code-area").value;

      // copy the text to the clipboard
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          // show success message
          message.textContent = "Text copied to clipboard!";
        })
        .catch((err) => {
          // show error message
          message.textContent = "Failed to copy text!";
          console.error("Error copying text:", err);
        });
    });

    // add label and textarea to container

    labelContainer.appendChild(label);
    labelContainer.appendChild(copyButton);
    container.appendChild(labelContainer);
    container.appendChild(textarea);
    container.append(message);

    // return container element
    return container;
  }

  function BatchGeoMapContextMenu() {
    var appState = BatchGeoStore.getState().App;
    var strings = BatchGeoStrings.getStringsForComponent(
      "BatchGeoMapContextMenu",
    );
    if (!window.per.clusterIconSelOptions) {
      window.createClusterSelectOptions();
    }

    if (!window.per.map_render_type) {
      window.per.map_render_type = { type: "marker" };
    }

    return BatchGeoContextMenu({
      triggerEl: ".map-page #mapDiv",
      renderControl: window.per.isMapPreview ? false : true,
      menuItems: [
        {
          label: strings.get("EDIT_MAP"),
          icon: "context-edit",
          visibility: [
            appState.currentUser.isMapOwner,
            !BatchGeoDevices.is("iosapp"),
          ],
          callback: function () {
            window.location =
              "/map/edit/?map_id=" +
              appState.mapId +
              "&d=" +
              appState.mapSecret;
          },
        },
        {
          label: strings.get("DATA_VIEW"),
          icon: "context-data",
          // The render method of 0 == map + data, 1 == map only
          visibility: [
            appState.mapMode !== "store_locator",
            appState.mapRenderMethod !== 1 || appState.pro,
            !window.per.hideaddr_cb || appState.pro,
            appState.mapRenderMethod === 0 || appState.pro,
          ],
          selected: function () {
            return BatchGeoStore.getState().BatchGeoTableMap.visibility;
          },
          callback: function () {
            BatchGeoStore.dispatch({ type: "TABLE_MAP_VISIBILITY_TOGGLE" });
            BatchGeoStore.dispatch({
              type: "FEATURE_TOGGLE",
              feature: "shouldRenderTable",
            });
            window.batchGeoMap.bgSize(true);
          },
        },
        {
          label: strings.get("CHOROPLETH_VIEW"),
          icon: "context-choropleth",
          visibility: [
            !window.per.map_render_type.choroplethUnavailable,
            !window.per.disableChoropleth,
            window.per.map_render_type.detailLevel !== undefined,
          ],
          selected: () =>
            window.per.map_render_type.type === "choropleth" ? true : false,
          callback: () => {
            if (BatchGeoStore.getState().HeatMap.enabled === true) {
              BatchGeoStore.dispatch({ type: "HEATMAP_DISABLE" });
            }

            window.per.map_render_type.type =
              window.per.map_render_type.type === "choropleth"
                ? "marker"
                : "choropleth";
            window.batchGeoGoogleMapsManager.doMap(true);
          },
        },
        {
          label: strings.get("HEAT_VIEW"),
          icon: "context-heat",
          visibility: [
            window.per.map_render_type.type !== "choropleth",
            appState.proMap || appState.pro,
          ],
          selected: function () {
            return BatchGeoStore.getState().HeatMap.enabled;
          },
          callback: function () {
            if (BatchGeoStore.getState().HeatMap.enabled !== true) {
              BatchGeoStore.dispatch({ type: "HEATMAP_ENABLE" });
              window.batchGeoGoogleMapsMarker.MarkerDrawer.clearFilteredMarkers();
            } else {
              BatchGeoStore.dispatch({ type: "HEATMAP_DISABLE" });
              window.batchGeoGoogleMapsMarker.MarkerDrawer.checkLabels();
            }

            window.BatchGeoTrack.event({
              featureName: "heatmap",
              eventName: "toggle",
              eventValue: BatchGeoStore.getState().HeatMap.enabled,
            });
          },
        },
        {
          label: strings.get("ADVANCED_MODE"),
          icon: "context-advanced",
          visibility: [appState.pro],
          selected: function () {
            return BatchGeoStore.getState().App.advanced;
          },
          callback: function () {
            BatchGeoStore.dispatch({
              type: "FEATURE_TOGGLE",
              feature: "advanced",
            });
          },
        },
        {
          label: strings.get("CLUSTER_VIEW"),
          icon: "context-cluster",
          visibility: [
            window.per.map_render_type.type !== "choropleth" ||
              window.per.disableChoropleth,
          ],
          selected: function () {
            return BatchGeoStore.getState().Cluster.enabled;
          },
          callback: function () {
            window.per.clustering_cb_status = !window.per.clustering_cb_status;
            BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
          },
          // if we have clustering options
          // render sub menu
          subMenu: window.per.clusterIconSelOptions.length
            ? [
                {
                  label: strings.get("CLUSTER_MARKER_COUNT"), // TODO use strings.get
                  icon: "context-cluster-count",
                  selected: function () {
                    return (
                      BatchGeoStore.getState().Cluster.enabled &&
                      window.per.clustering_icon_mode_sel == "average"
                    );
                  },
                  callback: function () {
                    // starting with clusters off
                    // selecting should enable cluster mode without any settings
                    if (!BatchGeoStore.getState().Cluster.enabled) {
                      resetClusterSettings();
                      window.per.clustering_cb_status =
                        !window.per.clustering_cb_status;
                      BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
                    }

                    // if starting with clusters on and no cluster settings
                    // selecting should disable clsuter mode
                    else if (this.selected()) {
                      window.per.clustering_cb_status =
                        !window.per.clustering_cb_status;
                      BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
                    }

                    // if starting with cluster on and valid cluster settings
                    // selecting should keep cluster on and remove the cluster settings
                    else if (
                      BatchGeoStore.getState().Cluster.enabled &&
                      window.per.clustering_icon_mode_sel !== "average"
                    ) {
                      resetClusterSettings();
                      BatchGeoStore.dispatch({ type: "CLUSTER_ENABLE" });
                    }

                    // force a rerender of context menu with new state
                    window.batchGeoGoogleMapsMarker.MarkerLegend.update(true);
                  },
                },
                {
                  label: strings.get("CLUSTER_SUM"),
                  icon: "context-cluster-sum",
                  selected: function () {
                    return (
                      BatchGeoStore.getState().Cluster.enabled &&
                      window.per.clustering_icon_mode_sel == "sum"
                    );
                  },
                  callback: function () {},
                  subMenu: window.per.clusterIconSelOptions.map((option) => {
                    return {
                      label: option.name,
                      icon: "context-cluster-sum-option",
                      selected: function () {
                        return (
                          BatchGeoStore.getState().Cluster.enabled &&
                          window.per.clustering_icon_mode_sel == "sum" &&
                          window.per.clustering_icon_col ===
                            option.clusteringIconColIndex
                        );
                      },
                      callback: function () {
                        // clusters is disabled
                        // enable with settings
                        if (!BatchGeoStore.getState().Cluster.enabled) {
                          setClusterSettings(
                            "sum",
                            option.clusteringIconColIndex,
                            true,
                          );
                          BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
                        }

                        // is selected
                        // reset settings and disable
                        else if (this.selected()) {
                          resetClusterSettings();
                          BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
                        }

                        // clusters is enabled and this menu item is enabled
                        // selecting clears settings and toggles
                        else if (
                          BatchGeoStore.getState().Cluster.enabled &&
                          !this.selected()
                        ) {
                          setClusterSettings(
                            "sum",
                            option.clusteringIconColIndex,
                            true,
                          );
                          BatchGeoStore.dispatch({ type: "CLUSTER_ENABLE" });
                        }

                        window.batchGeoGoogleMapsMarker.MarkerLegend.update(
                          true,
                        );
                      },
                    };
                  }),
                },
                {
                  label: strings.get("CLUSTER_AVG"),
                  icon: "context-cluster-avg",
                  selected: function () {
                    return (
                      BatchGeoStore.getState().Cluster.enabled &&
                      window.per.clustering_icon_mode_sel == "avg"
                    );
                  },
                  callback: function () {},
                  subMenu: window.per.clusterIconSelOptions.map((option) => {
                    return {
                      label: option.name,
                      icon: "context-cluster-avg-option",
                      selected: function () {
                        return (
                          window.per.clustering_icon_mode_sel == "avg" &&
                          window.per.clustering_icon_col ===
                            option.clusteringIconColIndex
                        );
                      },
                      callback: function () {
                        // clusters is disabled
                        // enable with settings
                        if (!BatchGeoStore.getState().Cluster.enabled) {
                          setClusterSettings(
                            "avg",
                            option.clusteringIconColIndex,
                            true,
                          );
                          BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
                        }

                        // is selected
                        // reset settings and disable
                        else if (this.selected()) {
                          resetClusterSettings();
                          BatchGeoStore.dispatch({ type: "CLUSTER_TOGGLE" });
                        }

                        // clusters is enabled and this menu item is enabled
                        // selecting clears settings and toggles
                        else if (
                          BatchGeoStore.getState().Cluster.enabled &&
                          !this.selected()
                        ) {
                          setClusterSettings(
                            "avg",
                            option.clusteringIconColIndex,
                            true,
                          );
                          BatchGeoStore.dispatch({ type: "CLUSTER_ENABLE" });
                        }

                        window.batchGeoGoogleMapsMarker.MarkerLegend.update(
                          true,
                        );
                      },
                    };
                  }),
                },
              ]
            : [],
        },
        {
          label: strings.get("EXPORT_GOOGLE_EARTH"),
          icon: "context-earth",
          visibility: [
            !window.per.disable_exports,
            appState.mapRenderMethod === 0 || appState.pro,
            !BatchGeoDevices.is("iosapp"),
          ],
          callback: function () {
            window.location = "/map/kml/" + appState.mapAlias;
          },
        },
        {
          label: strings.get("EXPORT_PDF_IMAGE"),
          icon: "context-export",
          visibility: [appState.pro, !BatchGeoDevices.is("iosapp")],
          callback: function () {
            // TODO(tom) seems like it's from $.colorbox, but no other reference in project
            window.imageDialog();
          },
        },
        {
          label: strings.get("PRINT"),
          icon: "context-print",
          callback: function () {
            window.batchGeoPrinter.dialog();
          },
        },
        {
          label: strings.get("RESET_MAP"),
          icon: "context-reset",
          callback: function () {
            window.batchGeoMap.mapReset();
          },
        },
        {
          label: "View Full Screen",
          icon: "context-zoom",
          visibility: [window.self !== window.top],
          callback: function () {
            if (document.documentElement.requestFullscreen) {
              document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
              // Firefox
              document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
              // Chrome/Safari
              document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
              // IE/Edge
              document.documentElement.msRequestFullscreen();
            }
          },
        },
        {
          label: "Embed Map",
          icon: "context-embed",
          callback: function () {
            // open a modal to display embed code
            BatchGeo.customDialog(createIframeCodeElement(), {
              showConfirmBtn: false,
              showDismissBtn: true,
              dismissText: "OK",
            });
          },
        },
        {
          label: "Contact Map Owner",
          icon: "context-contact",
          callback: () => {
            BatchGeoContactOwner.render();
          },
        },
      ],
    });
  }

  window.BatchGeoMapContextMenu = BatchGeoMapContextMenu;
})(window);
